export const getQueryParam = (paramName: string): string | null => {
    if (!paramName) {
        return null;
    }
    const queryString = window.location.search || window.location.hash.slice(1);

    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramName);
}